export function getExecutionDocType(): string {
  switch (Office.context.host) {
    case Office.HostType.PowerPoint:
      return "PowerPoint";
    case Office.HostType.Word:
      return "Word";
    default:
      return "browser";
  }
}
